import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '../lib/utils.js';
// Status pills: soft token-tinted (never the accent — status colour is reserved
// for state). `primary` is the brand/action tone, not a status. Tints are a low
// opacity of the semantic token over its own foreground, so they re-skin with
// the theme instead of the old hardcoded oklch literals.
const badgeVariants = cva('inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold', {
    variants: {
        tone: {
            neutral: 'border-transparent bg-muted text-muted-foreground',
            primary: 'border-transparent bg-accent text-accent-foreground',
            success: 'border-transparent bg-success/12 text-success',
            warning: 'border-transparent bg-warning/15 text-warning',
            danger: 'border-transparent bg-destructive/12 text-destructive',
            outline: 'border-border text-foreground',
        },
    },
    defaultVariants: { tone: 'neutral' },
});
export function Badge({ className, tone, ...props }) {
    return _jsx("span", { className: cn(badgeVariants({ tone }), className), ...props });
}
